import { unbrand } from "@/helpers/brand";

function getMenuItemsByRoleAndProductsRaw(internalParam) {
    let menu = []; 

    const role = JSON.parse(localStorage.getItem('auth.currentUser'))?.user?.role;

    const app = localStorage.getItem('app');

    if(!role)
        return;

    //const products = JSON.parse(localStorage.getItem('auth.currentUser')).user.company.products;
    
    if(role == 'superadmin'){

        menu.push({
            id: 1,
            label: "menu.general",
            isTitle: true
        }),

        menu.push({
            id: 4,
            label: "menu.general_tenants",
            icon: "bx-buildings",
            link: "/tenants",
        });
    }

    
    
    if((app && app == 'live') || role =='host'){
      if(role == 'host')
        menu.push({
            id: 10,
            label: "Go Live-Shopping",
            isTitle: true
        })
    

    if(role== 'admin'){
        menu.push(
            {
                id: 26,
                label: "menu.live_analyze",
                icon: "bx-bar-chart-alt-2",
                subItems:[
                    {
                        id: 3,
                        label: "menu.live_metrics",
                        icon: "bx-bar-chart-alt-2",
                        link: "/metrics",
                    },
                    {
                        id: 27,
                        label: "menu.live_calls",
                        icon: "bx-bar-chart-alt-2",
                        link: "/events-list",
                    }
                ]
            }
        );
        
        menu.push({
            id: 65,
            label: "Hosts",
            icon: "bx-group",
            link: "/hosts",
        });

        menu.push({
            id: 5,
            label: "menu.live_groups",
            icon: "bx bx-cube-alt",
            link: "/groups",
        });

        
        menu.push({
            id: 9,
            label: "menu.live_availability",
            icon: "bx bx-time-five",
            link: "/availability",
        });
        menu.push({
            id: 7,
            label: "menu.live_campaigns",
            icon: "bx bx-briefcase-alt-2",
            link: "/campaigns",
        });
        menu.push({
            id: 17,
            label: "menu.live_videos",
            icon: "bx bx-slideshow",
            link: "/videos",
            badge: {
                variant: "info",
                text: "Beta"
            }
        });
        menu.push({
            id: 8,
            label: "menu.live_events",
            icon: "bx bx-calendar-event",
            link: "/events",
        });
    }

    else if(role =='host'){

        menu.push({
            id:33,
            label:"menu.live_next_events",
            icon: "bx bx-task",
            link: "/next-events"
        });

        menu.push({
            id: 18,
            label: "menu.live_events",
            icon: "bx bx-calendar-event",
            link: "/events",
        });

        menu.push({
            id: 17,
            label: "menu.live_campaigns",
            icon: "bx bx-briefcase-alt-2",
            link: "/campaigns",
        });
    }
}
    if(app && app == 'search'){

        if (role == 'admin'){
            menu.push({
                id: 11,
                label: "Go Search",
                isTitle: true
            })

            menu.push({
                id: 20,
                label: "menu.search_config",
                icon: "bx bx-wrench",
                link: "/search-project",
            })

            menu.push({
                id: 21,
                label: "menu.search_analyze",
                icon: "bx bx-bar-chart",
                subItems:[
                    {
                        id: 34,
                        label: "menu.search_analyze_metrics",
                        icon: "bx-bar-chart-alt-2",
                        link: "/search-analyze",
                    },
                    {
                        id: 35,
                        label: "menu.search_analyze_clusters",
                        icon: "bx-bar-chart-alt-2",
                        link: "/search-clusters",
                    },
                    {
                        id: 37,
                        label: "menu.search_list",
                        icon: "bx-bar-chart-alt-2",
                        link: "/search-list",
                    },
                    {
                        id: 138,
                        label: "menu.search_improvements",
                        icon: "bx-bulb",
                        link: "/search-improvements",
                        badgeKey: "search_improvements",
                    },
                ]
            })
    }
    }

    if(app && app == 'reco'){
        if (role == 'admin'){
        
            menu.push({
                id: 23,
                label: "Go Recommendation",
                isTitle: true
            })

            menu.push({
                id: 24,
                label: "menu.reco_config",
                icon: "bx bx-wrench",
                link: "/reco-project",
            })

            menu.push({
                id: 25,
                label: "menu.reco_analyze",
                icon: "bx bx-bar-chart",
                link: "/reco-analyze",
            })
        }        
    }

    if(!app || app == 'personal'){
        if (role == 'admin'){
          
          menu.push({
            id: 233,
            label: "Dashboard",
            icon: "bx bx-home-circle",
            link: "/",
        });

        menu.push({
            id: 234,
            label: "Analytics",
            icon: "bx bx-line-chart",
            subItems:[
              {
                id: 3,
                label: "menu.recommendations",
                link: "/reco-analyze-v2"
              },
              {
                id: 4,
                label: "menu.personalizations",
                link: "/personal-analyze-v2",
              },
              {
                id: 42,
                label: "menu.broadcasts",
                link: "/broadcast-analyze-v2",
              },
             {
                id: 43,
                label: "menu.journeys",
                link: "/journey-analyze-v2",
              },
              {
                id: 44,
                label: "menu.project_analyze",
                link: "/project-analyze",
              },
              {
                id: 612,
                label: "menu.items_analyze",
                link: "/items-analyze",
              },
              {
                id: 613,
                label: "menu.surveys",
                link: "/surveys-analyze",
              },
              {
                id: 159,
                label: "Email transaccional",
                link: "/transactional-emails",
              },
              {
                id: 40,
                label: "menu.usage",
                link: "/usage",
              }
            ]
        });
        
        menu.push({
            id: 62,
            label: "menu.templates_store",
            icon: "bx bx-store",
            link: "/templates-store",
        });  
        
        menu.push({
            id: 55,
            label: "menu.segmentation",
            icon: "bx bx-layout",
            subItems:[
              {
                id: 155,
                label: "menu.contact_lists",
                icon: "bx bx-group",
                link: "/contact-lists",
              },
              {
                  id: 54,
                  label: "menu.audiences",
                  icon: "bx bx-group",
                  link: "/audiences",
              },
              {
                id: 154,
                label: "menu.audience_explorer",
                icon: "bx bx-group",
                link: "/audiences-explorer",
              }
            ]
        });

        menu.push({
                id: 57,
                label: "menu.personalizations",
                icon: "bx bxs-magic-wand",
                link: "/personalizations",
            })
            
            menu.push({
                id: 56,
                label: "menu.journeys",
                icon: "bx bx-directions",
                link: "/journeys",
            })

            menu.push({
              id: 58,
              label: "Broadcasts",
              icon: "bx bx-paper-plane",
              link: "/broadcasts",
            })

            menu.push({
                id: 60,
                label: "menu.customers",
                icon: "bx bx-id-card",
                link: "/customers",
            });

            menu.push({
                id: 534,
                label: "Addons",
                isTitle: true
            })

            menu.push({
                id: 535,
                label: "menu.gopersonal_auto",
                icon: "bx bx-bot",
                link: "/gopersonal-auto",
            })

            menu.push({
                id: 69,
                label: "Go Live Shopping",
                icon: "bx bx-video",
                subItems:[
                  /*{
                      id: 26,
                      label: "menu.live_analyze",
                      icon: "bx-bar-chart-alt-2",
                      parentId: 69,
                      subItems:[
                          {
                              id: 3,
                              label: "menu.live_metrics",
                              icon: "bx-bar-chart-alt-2",
                              link: "/metrics",
                              parentId: 26,
                          },
                          {
                              id: 27,
                              label: "menu.live_calls",
                              icon: "bx-bar-chart-alt-2",
                              link: "/events-list",
                              parentId: 26,
                          }
                      ]
                  },*/
                  {
                    id: 72,
                    label: "Analytics",
                    icon: "bx-group",
                    link: "/live-shopping-analyze",
                    parentId: 69,
                  },
                  {
                    id: 65,
                    label: "Hosts",
                    icon: "bx-group",
                    link: "/hosts",
                  },
                  {
                    id: 5,
                    label: "menu.live_groups",
                    icon: "bx bx-cube-alt",
                    link: "/groups",
                  },
                  {
                    id: 9,
                    label: "menu.live_availability",
                    icon: "bx bx-time-five",
                    link: "/availability",
                  },
                  {
                    id: 7,
                    label: "menu.live_campaigns",
                    icon: "bx bx-briefcase-alt-2",
                    link: "/campaigns",
                  },
                  {
                    id: 71,
                    label: "menu.live_calls",
                    icon: "bx-group",
                    link: "/events-list",
                    parentId: 69,
                  },
                  {
                    id:17,
                    label: "menu.live_videos",
                    icon: "bx bx-calendar-event",
                    link: "/videos",
                  },
                  {
                    id: 37,
                    label: "Shows",
                    icon: "bx bx-slideshow",
                    link: "/shows",
                  },
                  {
                    id: 8,
                    label: "menu.live_events",
                    icon: "bx bx-calendar-event",
                    link: "/events",
                  }
                  
                ]
            });  

            
            menu.push({
                id: 70,
                label: "Go Search",
                icon: "bx bx-search-alt",
                subItems:[
                  {
                      id: 134,
                      label: "menu.search_analyze_metrics",
                      icon: "bx-bar-chart-alt-2",
                      link: "/search-analyze-v2",
                  },
                  {
                      id: 37,
                      label: "menu.search_list",
                      icon: "bx-bar-chart-alt-2",
                      link: "/search-list",
                  },
                  {
                      id: 138,
                      label: "menu.search_improvements",
                      icon: "bx-bulb",
                      link: "/search-improvements",
                      badgeKey: "search_improvements",
                  },
                  {
                      id: 46,
                      label: "menu.search_settings",
                      icon: "bx-bar-chart-alt-2",
                      link: "/search-settings",
                  }   
                ]
                });
              menu.push({
                id: 71,
                label: "Go Loyalty",
                icon: "bx bx-award",
                subItems:[
                {
                    id: 32,
                    label: "loyalty.menu.dashboard",
                    icon: "bx-bar-chart-alt-2",
                    link: "/loyalty-dashboard",
                },
                {
                    id: 235,
                    label: "loyalty.menu.programs",
                    icon: "bx-bar-chart-alt-2",
                    link: "/loyalty-programs",
                },
                {
                    id: 33,
                    label: "loyalty.menu.members",
                    icon: "bx-bar-chart-alt-2",
                    link: "/loyalty-members",
                },
                {
                    id: 236,
                    label: "loyalty.menu.movements",
                    icon: "bx-bar-chart-alt-2",
                    link: "/loyalty-movements",
                },
                {
                    id: 34,
                    label: "loyalty.menu.levels",
                    icon: "bx-bar-chart-alt-2",
                    link: "/loyalty-levels",
                },
                {
                    id: 35,
                    label: "loyalty.menu.campaigns",
                    icon: "bx-bar-chart-alt-2",
                    link: "/loyalty-campaigns",
                },
                {
                    id: 238,
                    label: "loyalty.menu.rewards",
                    icon: "bx-bar-chart-alt-2",
                    link: "/loyalty-rewards",
                },
                {
                    id: 239,
                    label: "loyalty.menu.vouchers",
                    icon: "bx-bar-chart-alt-2",
                    link: "/loyalty-vouchers",
                },
                {
                    id: 237,
                    label: "loyalty.menu.simulator",
                    icon: "bx-bar-chart-alt-2",
                    link: "/loyalty-simulator",
                },
                ]
                });

            
            menu.push({
              id: 72,
              label: "Personal Shopper",
              icon: "bx bx-message-alt",
              link: "/shopper",
            })

            menu.push({
              id: 533,
              label: "General",
              isTitle: true
            }) 
            
            menu.push({
              id: 61,
              label: "menu.integrations",
              icon: "bx bx-link",
              link: "/integrations",
            });

            menu.push({
              id: 611,
              label: "menu.calvin_tasks",
              icon: "bx bx-task",
              link: "/calvin-tasks",
            });

            menu.push({
                id: 48,
                label: "Items",
                icon: "bx bx-purchase-tag-alt",
                link: "/items",
            });
            menu.push({
                id: 36,
                label: "menu.recommendations",
                icon: "bx bx-star",
                subItems:[
                  {
                    id: 149,
                    label: "menu.recommendations_academy",
                    icon: "bx bx-star",
                    link: "https://academy.gopersonal.ai/guia-de-usuario/recomendaciones/estrategias-de-recomendaciones",
                  },
                  {
                    id: 49,
                    label: "menu.custom_strategies",
                    icon: "bx bx-star",
                    link: "/custom-strategies",
                  },
                  {
                    id: 614,
                    label: "menu.reco_tester",
                    icon: "bx bx-star",
                    link: "/reco-tester",
                  }
                ]
            });

            menu.push({
              id: 73,
              label: "menu.catalogs",
              icon: "bx bx-package",
              subItems:[
              {
                  id: 62,
                  label: "menu.properties",
                  icon: "",
                  link: "/properties",
                },
                /*{
                  id: 67,
                  label: "menu.property_groups",
                  icon: "",
                  link: "/property-groups",
                },*/
                {
                  id: 63,
                  label: "menu.interactions",
                  icon: "",
                  link: "/interactions",
                },
                /*{
                  id: 64,
                  label: "menu.goals",
                  icon: "",
                  link: "/goals",
                },*/
                /*{
                  id: 65,
                  label: "menu.custom_strategies",
                  icon: "",
                  link: "/custom-strategies",
                },*/
                {
                  id: 66,
                  label: "menu.email_components",
                  icon: "",
                  link: "/email-components",
                },
                {
                    id: 56,
                    label: "menu.catalogs_templates",
                    icon: "",
                    link: "/templates",
                },
                {
                  id: 57,
                  label: "menu.exports",
                  icon: "",
                  link: "/exports",
                }
              ]
            });

            
            if(window.config.local || internalParam){
              menu.filter(m=>m.id== 73)[0].subItems.push({
                  id: 2,
                  label: "GP Templates Store",
                  icon: "bx-bar-chart-alt-2",
                  link: "/gp-templates-store"
                })
            }
            
            menu.push({
                id: 6,
                label: "menu.general_users",
                icon: "bx-user",
                link: "/users",
            });
        }        
    }

    return menu;
}

function getMenuItemsByRoleAndProductsDataForSalesRaw(internalParam) {
  let menu = []; 

  const role = JSON.parse(localStorage.getItem('auth.currentUser'))?.user?.role;

  if(!role)
      return;

  if(role == 'superadmin'){

      menu.push({
          id: 1,
          label: "menu.general",
          isTitle: true
      }),

      menu.push({
          id: 4,
          label: "menu.general_tenants",
          icon: "bx-buildings",
          link: "/tenants",
      });
  }
  else if (role == 'admin'){
        
        menu.push({
          id: 233,
          label: "Dashboard",
          icon: "bx bx-home-circle",
          link: "/",
      });

      menu.push({
          id: 234,
          label: "Analytics",
          icon: "bx bx-line-chart",
          subItems:[
            {
              id: 3,
              label: "menu.recommendations",
              link: "/reco-analyze-v2"
            },
            {
              id: 4,
              label: "menu.personalizations",
              link: "/personal-analyze-v2",
            },
            {
              id: 44,
              label: "menu.project_analyze",
              link: "/project-analyze",
            },
            {
              id: 612,
              label: "menu.items_analyze",
              link: "/items-analyze",
            },
            {
              id: 613,
              label: "menu.surveys",
              link: "/surveys-analyze",
            },
            {
              id: 40,
              label: "menu.usage",
              link: "/usage",
            }
          ]
      });
      
      menu.push({
          id: 62,
          label: "menu.templates_store",
          icon: "bx bx-store",
          link: "/templates-store",
      });  
      
      menu.push({
          id: 55,
          label: "menu.segmentation",
          icon: "bx bx-layout",
          subItems:[
            {
              id: 155,
              label: "menu.contact_lists",
              icon: "bx bx-group",
              link: "/contact-lists",
            },
            {
                id: 54,
                label: "menu.audiences",
                icon: "bx bx-group",
                link: "/audiences",
            },
            {
              id: 154,
              label: "menu.audience_explorer",
              icon: "bx bx-group",
              link: "/audiences-explorer",
            }
          ]
      });

      menu.push({
              id: 57,
              label: "menu.personalizations",
              icon: "bx bxs-magic-wand",
              link: "/personalizations",
          })
          
          menu.push({
              id: 60,
              label: "menu.customers",
              icon: "bx bx-id-card",
              link: "/customers",
          });

          menu.push({
              id: 534,
              label: "Addons",
              isTitle: true
          })

          menu.push({
              id: 535,
              label: "menu.gopersonal_auto",
              icon: "bx bx-bot",
              link: "/gopersonal-auto",
          })

          menu.push({
              id: 69,
              label: "Go Live Shopping",
              icon: "bx bx-broadcast",
              subItems:[
                /*{
                    id: 26,
                    label: "menu.live_analyze",
                    icon: "bx-bar-chart-alt-2",
                    parentId: 69,
                    subItems:[
                        {
                            id: 3,
                            label: "menu.live_metrics",
                            icon: "bx-bar-chart-alt-2",
                            link: "/metrics",
                            parentId: 26,
                        },
                        {
                            id: 27,
                            label: "menu.live_calls",
                            icon: "bx-bar-chart-alt-2",
                            link: "/events-list",
                            parentId: 26,
                        }
                    ]
                },*/
                {
                  id: 72,
                  label: "Analytics",
                  icon: "bx-group",
                  link: "/live-shopping-analyze",
                  parentId: 69,
                },
                {
                  id: 65,
                  label: "Hosts",
                  icon: "bx-group",
                  link: "/hosts",
                },
                {
                  id: 5,
                  label: "menu.live_groups",
                  icon: "bx bx-cube-alt",
                  link: "/groups",
                },
                {
                  id: 9,
                  label: "menu.live_availability",
                  icon: "bx bx-time-five",
                  link: "/availability",
                },
                {
                  id: 7,
                  label: "menu.live_campaigns",
                  icon: "bx bx-briefcase-alt-2",
                  link: "/campaigns",
                },
                {
                  id: 71,
                  label: "menu.live_calls",
                  icon: "bx-group",
                  link: "/events-list",
                  parentId: 69,
                },
                {
                  id:17,
                  label: "menu.live_videos",
                  icon: "bx bx-calendar-event",
                  link: "/videos",
                },
                {
                  id: 37,
                  label: "Shows",
                  icon: "bx bx-slideshow",
                  link: "/shows",
                },
                {
                  id: 8,
                  label: "menu.live_events",
                  icon: "bx bx-calendar-event",
                  link: "/events",
                }
                
              ]
          });  

          
          menu.push({
              id: 70,
              label: "Go Search",
              icon: "bx bx-search-alt",
              subItems:[
                {
                    id: 134,
                    label: "menu.search_analyze_metrics",
                    icon: "bx-bar-chart-alt-2",
                    link: "/search-analyze-v2",
                },
                {
                    id: 37,
                    label: "menu.search_list",
                    icon: "bx-bar-chart-alt-2",
                    link: "/search-list",
                },
                {
                    id: 138,
                    label: "menu.search_improvements",
                    icon: "bx-bulb",
                    link: "/search-improvements",
                    badgeKey: "search_improvements",
                },
                {
                    id: 46,
                    label: "menu.search_settings",
                    icon: "bx-bar-chart-alt-2",
                    link: "/search-settings",
                }   
              ]
              });
            menu.push({
              id: 71,
              label: "Go Loyalty",
              icon: "bx bx-award",
              subItems:[
              {
                  id: 32,
                  label: "loyalty.menu.dashboard",
                  icon: "bx-bar-chart-alt-2",
                  link: "/loyalty-dashboard",
              },
              {
                  id: 235,
                  label: "loyalty.menu.programs",
                  icon: "bx-bar-chart-alt-2",
                  link: "/loyalty-programs",
              },
              {
                  id: 33,
                  label: "loyalty.menu.members",
                  icon: "bx-bar-chart-alt-2",
                  link: "/loyalty-members",
              },
              {
                  id: 236,
                  label: "loyalty.menu.movements",
                  icon: "bx-bar-chart-alt-2",
                  link: "/loyalty-movements",
              },
              {
                  id: 34,
                  label: "loyalty.menu.levels",
                  icon: "bx-bar-chart-alt-2",
                  link: "/loyalty-levels",
              },
              {
                  id: 35,
                  label: "loyalty.menu.campaigns",
                  icon: "bx-bar-chart-alt-2",
                  link: "/loyalty-campaigns",
              },
              {
                  id: 238,
                  label: "loyalty.menu.rewards",
                  icon: "bx-bar-chart-alt-2",
                  link: "/loyalty-rewards",
              },
              {
                  id: 239,
                  label: "loyalty.menu.vouchers",
                  icon: "bx-bar-chart-alt-2",
                  link: "/loyalty-vouchers",
              },
              {
                  id: 237,
                  label: "loyalty.menu.simulator",
                  icon: "bx-bar-chart-alt-2",
                  link: "/loyalty-simulator",
              },
              ]
              });

          
          menu.push({
            id: 72,
            label: "Personal Shopper",
            icon: "bx bx-message-alt",
            link: "/shopper",
          })

          menu.push({
            id: 533,
            label: "General",
            isTitle: true
          }) 
          
          menu.push({
            id: 61,
            label: "menu.integrations",
            icon: "bx bx-link",
            link: "/integrations",
          });

          menu.push({
            id: 611,
            label: "menu.calvin_tasks",
            icon: "bx bx-task",
            link: "/calvin-tasks",
          });

          menu.push({
              id: 48,
              label: "Items",
              icon: "bx bx-purchase-tag-alt",
              link: "/items",
          });
          menu.push({
              id: 36,
              label: "menu.recommendations",
              icon: "bx bx-star",
              subItems:[
                {
                  id: 149,
                  label: "menu.recommendations_academy",
                  icon: "bx bx-star",
                  link: "https://academy.gopersonal.ai/guia-de-usuario/recomendaciones/estrategias-de-recomendaciones",
                },
                {
                  id: 49,
                  label: "menu.custom_strategies",
                  icon: "bx bx-star",
                  link: "/custom-strategies",
                },
                {
                  id: 614,
                  label: "menu.reco_tester",
                  icon: "bx bx-star",
                  link: "/reco-tester",
                }
              ]
          });

          menu.push({
            id: 73,
            label: "menu.catalogs",
            icon: "bx bx-package",
            subItems:[
            {
                id: 62,
                label: "menu.properties",
                icon: "",
                link: "/properties",
              },
              /*{
                id: 67,
                label: "menu.property_groups",
                icon: "",
                link: "/property-groups",
              },*/
              {
                id: 63,
                label: "menu.interactions",
                icon: "",
                link: "/interactions",
              },
              /*{
                id: 64,
                label: "menu.goals",
                icon: "",
                link: "/goals",
              },*/
              /*{
                id: 65,
                label: "menu.custom_strategies",
                icon: "",
                link: "/custom-strategies",
              },*/
              {
                  id: 56,
                  label: "menu.catalogs_templates",
                  icon: "",
                  link: "/templates",
              },
              {
                id: 57,
                label: "menu.exports",
                icon: "",
                link: "/exports",
              }
            ]
          });

          
          if(window.config.local || internalParam){
            menu.filter(m=>m.id== 73)[0].subItems.push({
                id: 2,
                label: "GP Templates Store",
                icon: "bx-bar-chart-alt-2",
                link: "/gp-templates-store"
              })
          }
          
          menu.push({
              id: 6,
              label: "menu.general_users",
              icon: "bx-user",
              link: "/users",
          });
      }else if (role == 'host'){
        menu.push({
            id: 10,
            label: "Go Live-Shopping",
            isTitle: true
        })

        menu.push({
            id:33,
            label:"menu.live_next_events",
            icon: "bx bx-task",
            link: "/next-events"
        });

        menu.push({
            id: 18,
            label: "menu.live_events",
            icon: "bx bx-calendar-event",
            link: "/events",
        });

        menu.push({
            id: 17,
            label: "menu.live_campaigns",
            icon: "bx bx-briefcase-alt-2",
            link: "/campaigns",
        });
      }        
  

  return menu;
}

// White-label: los títulos del menú sin la marca ("Go Personal Shopper" → "Personal Shopper").
function unbrandMenu(items) {
  return (items || []).map((item) => ({
    ...item,
    ...(typeof item.label === "string" ? { label: unbrand(item.label) } : {}),
    ...(Array.isArray(item.subItems) ? { subItems: unbrandMenu(item.subItems) } : {}),
  }));
}

export function getMenuItemsByRoleAndProducts(internalParam) {
  return unbrandMenu(getMenuItemsByRoleAndProductsRaw(internalParam));
}

export function getMenuItemsByRoleAndProductsDataForSales(internalParam) {
  return unbrandMenu(getMenuItemsByRoleAndProductsDataForSalesRaw(internalParam));
}
